import { normalizeCategory } from "../../../normalizers/normalizeCategory";
import { normalizeParentQuantity } from "../../../normalizers/normalizeParentQuantity";
import { normalizeQuantity } from "../../../normalizers/normalizeQuantity";
import { ensureCategory, ensureParent, registerQuantity } from "../helper";


function handleDirectQuantityCreation(
    state,
    category,
    quantityDefinition
) {
    const registration = registerQuantity(
        state.quantitiesById,
        quantityDefinition,
        "direct",
        true,
        normalizeQuantity,
    );

    if (!registration) {
        return state;
    }

    const { quantity, quantitiesById } = registration;

    const {
        categoryId,
        categoriesById,
        categoryIds,
    } = ensureCategory(state, category);

    const categoryNode = categoriesById[categoryId];

    categoriesById[categoryId] = {
        ...categoryNode,
        direct: [...categoryNode.direct, quantity],
    };

    return {
        ...state,
        quantitiesById,
        categoriesById,
        categoryIds,
    };
}

function handleParentBasedQuantityCreation(
    state,
    category,
    parent,
    quantityDefinition
) {
    console.log('qd in handleParentBasedQuantityCreation is: ', quantityDefinition)
    const registration = registerQuantity(
        state.quantitiesById,
        quantityDefinition,
        "quantity",
        false,
        normalizeQuantity,
    );

    if (!registration) {
        return state;
    }

    let { quantity, quantitiesById } = registration;

    const parentNode = ensureParent(
        quantitiesById,
        parent,
        normalizeParentQuantity,
    );

    parentNode.quantityDefinitions = [
        ...parentNode.quantityDefinitions,
        quantity,
    ];

    quantitiesById[`p${parent.id}`] = parentNode;

    const {
        categoryId,
        categoriesById,
        categoryIds,
    } = ensureCategory(state, category, normalizeCategory);

    const categoryNode = categoriesById[categoryId];

    const parentExists = categoryNode.parents.some(
        p => p.id === parent.id
    );

    categoriesById[categoryId] = {
        ...categoryNode,
        parents: parentExists
            ? categoryNode.parents.map(p =>
                  p.id === parent.id
                      ? parentNode
                      : p
              )
            : [...categoryNode.parents, parentNode],
    };

    return {
        ...state,
        quantitiesById,
        categoriesById,
        categoryIds,
    };
}

export function handleAdminQuantityDefinitionCreated(state, payload) {
    const { category, parent, quantity_definition } = payload;
    
    // Check if this is a direct quantity
    const isDirect = quantity_definition.is_direct === true || parent == null;
    
    if (isDirect) {
        return handleDirectQuantityCreation(state, category, quantity_definition);

    } else {
        return handleParentBasedQuantityCreation(state, category, parent, quantity_definition);
    }
}